module.exports = __webpack_public_path__ + "static/media/img-trending-products-row.1ced63f4.png";